module.exports = __webpack_public_path__ + "static/media/chip.730fad8f.png";